import * as yup from "yup";

const phoneRegExp =
  /^(?:\+[0-9]\s?)?(?:[0-9]{3}-|\([0-9]{3}\)\s?)[0-9]{3}-[0-9]{4}$/;
const phoneRegExp2 = /^\+?[1-9]\d{1,14}$/;
const nameRegExp = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$/gi;
const websiteRegExp =
  /((https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
const linkedInRegExp = /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;
const emailRegExp = /^[\w-.+]+@[\w-]+\.[\w-]{2,4}$/g

export const registrationSchema = yup.object().shape({
  avatar: yup.string().required('Uploading photo is required'),
  emailAddress: yup.string().matches( emailRegExp, "This must be a valid email address").required("Email Address is a required field"),
  firstName: yup
    .string()
    .matches(nameRegExp, "Only English Alphabet allowed")
    .required("First Name is a required field"),
  lastName: yup
    .string()
    .matches(nameRegExp, "Only English Alphabet allowed")
    .required("Last Name is a required field"),
  description: yup.string().required("Professional Bio is a required field"),
  gender: yup.string().required("Gender is a required field"),
  isParent: yup.string().required('Parent field is a required field'),
  ethnicity: yup.string().required("Ethnicity is a required field"),
  dateOfBirth: yup.string().required('Date of birth is a required field'),
  phoneNumber: yup.string()
    .matches(phoneRegExp2, "Unacceptable phone number format")
    .required("Phone Number is a required field. No spaces or special characters"),
  website: yup.string()
    .matches(websiteRegExp, "Website link must be valid URL"),
  address1: yup.string().required("Address is a required field"),
  address2: yup.string(),
  city: yup.string().required("City is a required field"),
  state: yup.string().required("State is a required field"),
  zipcode: yup.string().required("Zip code is a required field"),
  levelOfEducation: yup.string().required('Level of education is a required field'),
  fieldOfStudy: yup.string(),
  jobTitle: yup.string().required('Job title is a required field'),
  company: yup.string(),
  employmentStatus: yup.string().required('Employment status is a required field'),
  openToPromotional: yup.string().required('Open to Promotion info is a required field'),
  areasOfExpertise: yup.string().required('Areas Of Expertise are required'),
  previousContent: yup.string(),
  // professions: yup.array()
  //   .min(1, "At least 1 category is a required field")
  //   .max(2, "At most 2 categories are allowed")
  //   .required("Professions is a required field"),
  instagram: yup
    .string(),
  twitter: yup
    .string(),
  linkedin: yup
    .string()
    .matches(linkedInRegExp, "LinkedIn link must be valid URL"),
  referringSource: yup.string().required("Source of referral is a required field"),
  password: yup.string()
  .min(8, "Password must be at least 8 characters")
  .required("Password is required"),
  passwordConfirmation: yup.string()
  .oneOf([yup.ref("password"), null], "Passwords must match")
  .required("Confirm Password is required")
  // msaAgreementSigned: yup.bool().oneOf([true], 'Field must be checked'),
});

// The "Continue with Google" path: the email is Google's (locked, and the
// API takes it from its own session, so its format rule doesn't apply) and
// there is no password. Everything else is validated exactly as before.
export const googleRegistrationSchema = registrationSchema.omit([
  'emailAddress',
  'password',
  'passwordConfirmation',
]);

export const initialValues = {
  emailAddress: '',
  firstName: '',
  lastName: '',
  description: '',
  gender: '',
  isParent: '',
  ethnicity: '',
  dateOfBirth: '',
  phoneNumber: '',
  website: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipcode: '',
  levelOfEducation: '',
  fieldOfStudy: '',
  jobTitle: '',
  company: '',
  employmentStatus: '',
  professions: [],
  openToPromotional: '',
  areasOfExpertise: '',
  previousContent: '',
  instagram: '',
  twitter: '',
  linkedin: '',
  referringSource: '',
  msaAgreementSigned: false,
  password:'',
  passwordConfirmation: '',
  avatar: ''
};
